// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

var MassRevenueWriteOffController = function ($scope, $http, $routeParams, $window, $location, PaymentProviderSettings,
    ProductInfo, BulkUpdateContractsFilterBag, MassWriteOffs, gettext, gettextCatalog, 
    ReportDownloadService, AccountingExportSettings, RevenueWriteOffHelper, PUtill, DatepickerUtils) {
    $scope.flagToSwitchToExecuteTab = true;
    $scope.isLegendCollapsed = true;
    /* Translations */

    $scope.previewTabHeading = gettext('Create preview');
    $scope.executeTabHeading = gettext('Execute write-off');
    $scope.invalidPaymentMethodString = gettext('Invalid payment methods');
    $scope.invalidPaymentMethodsDescription = gettext('Contains contracts with payment methods that do not have a valid configuration');
    $scope.daysOverdueTooltip = gettext('The minimum amount of days the newest open receivable in each contract has to be overdue');
    $scope.daysSinceEndedTooltip = gettext('The minimum amount of days since the selected contracts have ended');
    $scope.escalationFilishedDaysTooltip = gettext('If the last escalation step was a dunning letter, the days are being counted from the date the dunning was sent. Contracts with no escalation process set are excluded. Note that the escalation process can differ between contracts');
    $scope.excludeSuspendedTooltip = gettext('You can use this filter to exclude specific contracts from the mass write-off by suspending the escalation process in those contracts');
    $scope.reportFormatTooltip = gettext('You can choose the format only for the first attempt of report generation; later downloads don’t provide format options');
    $scope.reportTypePreview = gettext('Preview version');
    $scope.reportTypeExecution = gettext('Execution version');

    $scope.disabledButtonTooltipText_InProgress = gettext('Only one mass write-off operation can be in progress at the same time');
    $scope.disabledButtonTooltipText_Filter = gettext('Please set a currency, select at least one payment method and choose a booking date to create a preview');
    
    $scope.legendText = Object.freeze({
        Orange: gettext('mass write-off preview or execution is in progress'),
        Blue: gettext('preview version is ready and can be executed'),
        Green: gettext('mass write-off was successfully executed'),
        Gray: gettext('preview version is outdated and so can\'t be used for execution')
    });

    /* Filter & Preview */
    
    $scope.maxDate = moment().tz(PUtill.BerlinTzName).endOf('month').toDate();
    $scope.pageTake = 20;
    
    // Creating this object because of https://www.youtube.com/watch?v=DTx23w4z6Kc&ab_channel=JohnLindquist
    // (or https://github.com/angular/angular.js/wiki/Understanding-Scopes)
    // Otherwise e.g. isPreviewDisabled() couldn't get a fresh BookingDate value; since booking date
    // datepicker is placed inside the tab set, it's being accessed inside the child scope
    $scope.scopeHolder = {
        Filter: BulkUpdateContractsFilterBag.filter ? BulkUpdateContractsFilterBag.filter : emptyFilter(),
        ShowOutdatedPreviews: false,
        Tab: "preview",
        IsLoading: true,
        BookingDateConstraints : {},
        ReportLocale: "de-DE",
        CurrenciesAvailable: []
    };
    
    function emptyFilter() {
        return {
            PaymentMethods: { },
            ExcludeSuspendedEscalations: true,
            Currency: ""
        };
    }
    
    function setDatePickerRange(){
        AccountingExportSettings.get({},
            function (accountingSettings) {
                $scope.scopeHolder.BookingDateConstraints = RevenueWriteOffHelper.getBookingDateConstraints(accountingSettings.FinalizedDate);
            });
    }

    PaymentProviderSettings.names().then(function (data) {
        $scope.listProviders = data;
        $scope.setPaymentMethodsCheckedValueTo(true);
        
        setDatePickerRange();
        
        $scope.productInfo = ProductInfo.get(function (data) {
            $scope.scopeHolder.Filter.Currency = "";

            function onlyUnique(value, index, self) { return self.indexOf(value) === index; }
            $scope.scopeHolder.CurrenciesAvailable = data.PlanGroups.map(function (x) { return x.Currency; }).filter(onlyUnique);

            $scope.$watch('massWriteOffs.items', function (items) {
                if ((items || []).length > 0) {
                    enableAutoreloadIfNeeded();
                    BulkUpdateContractsFilterBag.clean();

                    angular.forEach($scope.massWriteOffs.items, function (massWriteOff) {
                        if (massWriteOff.Filter.PaymentMethods)
                            massWriteOff.Filter.PaymentMethodsNames = $scope.paymentMethodNames(massWriteOff.Filter.PaymentMethods);

                        let canHavePreviewReport = massWriteOff.Status === "Preview" && massWriteOff.PreviewReportId == null;
                        let canHaveExecutionReport = massWriteOff.Status === "Executed" && massWriteOff.ExecutionReportId == null;
                        
                        massWriteOff._newReportMode = (canHavePreviewReport ? $scope.reportTypePreview
                            : (canHaveExecutionReport ? $scope.reportTypeExecution : null));
                    });

                    let filterToTakePaymentMethodsFrom = $scope.massWriteOffs.items[0].Filter;
                    $scope.scopeHolder.Filter = angular.copy(filterToTakePaymentMethodsFrom);
                    $scope.scopeHolder.Filter.PaymentMethods = { };
                    if (filterToTakePaymentMethodsFrom.PaymentMethods.length > 0) {
                        $scope.setPaymentMethodsCheckedValueTo(false);
                        let notInvalidMethods = filterToTakePaymentMethodsFrom.PaymentMethods.filter(function (x) { return !x.startsWith("-1"); });
                        angular.forEach(notInvalidMethods, function (paymentMethod) {
                            $scope.checkPaymentMethod(paymentMethod);
                        });
                        
                        if (notInvalidMethods.length !== filterToTakePaymentMethodsFrom.PaymentMethods.length)
                            $scope.checkPaymentMethod('Invalid:Invalid');
                    }
                    refreshAllOptionValue();

                    selectMassWriteOff($scope.scopeHolder.ShowOutdatedPreviews);

                    if (!$scope.anyNotOutdated())
                        $scope.scopeHolder.ShowOutdatedPreviews = true;
                } else {
                    $scope.selectedMassWriteOff = null;
                }
            });
            
            $scope.scopeHolder.IsLoading = false;
            $scope.scopeHolder.Tab = "preview";
        });
    });

    $scope.resetFilter = function() {
        $scope.scopeHolder.Filter = emptyFilter();
        $scope.setPaymentMethodsCheckedValueTo(true);
        $scope.scopeHolder.BookingDateConstraints.bookingDate = null;
    }

    $scope.setPaymentMethodsCheckedValueTo = function (newValue) {
        if (newValue === true && $scope.scopeHolder.Filter.PaymentMethods['All'] === newValue)
            return;

        setAllPaymentMethodsTo(newValue);
        $scope.scopeHolder.Filter.PaymentMethods['Invalid:Invalid'] = newValue;
        $scope.scopeHolder.Filter.PaymentMethods['All'] = newValue;
    }

    function setAllPaymentMethodsTo(boolean) {
        angular.forEach($scope.listProviders || [], function (paymentMethod) {
            $scope.scopeHolder.Filter.PaymentMethods[paymentMethod.key] = boolean;
        });
    }

    $scope.checkPaymentMethod = function (paymentMethod) {
        $scope.scopeHolder.Filter.PaymentMethods[paymentMethod] = !$scope.scopeHolder.Filter.PaymentMethods[paymentMethod];
        refreshAllOptionValue();
    }

    $scope.singleLeft = function(paymentMethod) {
        return Object.values($scope.scopeHolder.Filter.PaymentMethods).filter(function (x) { return x === true; }).length <= 1 &&
            $scope.scopeHolder.Filter.PaymentMethods[paymentMethod] === true;
    }

    function refreshAllOptionValue() {
        if ($scope.scopeHolder.Filter.PaymentMethods['All'] === undefined) {
            $scope.setPaymentMethodsCheckedValueTo(true);
        }

        $scope.scopeHolder.Filter.PaymentMethods['All'] = undefined;
        $scope.scopeHolder.Filter.PaymentMethods['All'] = Object.values($scope.scopeHolder.Filter.PaymentMethods).indexOf(false) === -1;
    }

    $scope.paymentMethodNames = function (roleProvider) {
        let containsInvalid = false;
        let names = Object.entries(roleProvider).map(function (x) {
            let split = x[1].split(":");
            return { Role: split[0], Provider: split[1] }; 
        }).map(function (x) {
            let isInvalid = x.Role === "-1";
            containsInvalid = containsInvalid || isInvalid;
            return isInvalid ? $scope.invalidPaymentMethodString : PaymentProviderSettings.toKeyNamePair(x.Role, x.Provider).name;
        });
        
        if (containsInvalid) {
            names = names.filter(function (x) { return x !== $scope.invalidPaymentMethodString; });
            names.push($scope.invalidPaymentMethodString);
        }
        
        return names;
    }

    $scope.isPreviewDisabled = function() {
        return $scope.filtersNotSet() || $scope.anyMassWriteOffInProcessing();
    };
    
    $scope.filtersNotSet = function () {
        return !$scope.scopeHolder.BookingDateConstraints.bookingDate ||
            !$scope.scopeHolder.Filter.Currency ||
            $scope.scopeHolder.BookingDateConstraints.bookingDateIsInClosedPeriod ||
            ($scope.scopeHolder.Filter.DaysOverdue && $scope.scopeHolder.Filter.DaysOverdue.$invalid) ||
            ($scope.scopeHolder.Filter.DaysSinceEnded && $scope.scopeHolder.Filter.DaysSinceEnded.$invalid) ||
            ($scope.scopeHolder.Filter.DaysSinceEscalationFinished && $scope.scopeHolder.Filter.DaysSinceEscalationFinished.$invalid);
    }

    $scope.createPreview = function() {
        let filterBody = angular.copy($scope.scopeHolder.Filter);
        filterBody.PaymentMethods = (filterBody.PaymentMethods['All'] === true) ? [] :
            Object.entries(filterBody.PaymentMethods)
                .filter(function (x) { return x[1]; })
                .map(function (x) { return x[0]; });

        if (!filterBody.DaysOverdue && filterBody.DaysOverdue !== 0)
            filterBody.DaysOverdue = null;

        if (!filterBody.DaysSinceEnded && filterBody.DaysSinceEnded !== 0)
            filterBody.DaysSinceEnded = null;

        if (!filterBody.DaysSinceEscalationFinished && filterBody.DaysSinceEscalationFinished !== 0)
            filterBody.DaysSinceEscalationFinished = null;

        let bookingDateMoment = moment($scope.scopeHolder.BookingDateConstraints.bookingDate).tz(PUtill.BerlinTzName);
        filterBody.BookingDate = PUtill.toShortDateString(bookingDateMoment);
        
        $http({
            method: "POST",
            url: "/api/v1/massWriteOff/preview",
            data: filterBody,
        }).then(
            function () {
                getMassWriteOffs();
                $scope.scopeHolder.Tab = "execute";
            }
        );
    };

    $scope.isExecutionDisabled = function () {
        return $scope.anyMassWriteOffInProcessing();
    }

    $scope.anyMassWriteOffInProcessing = function() {
        return $scope.massWriteOffs && $scope.massWriteOffs.items.some(function (x) { return x.IsInProcessing; });
    }

    /* Here starts the Execution */

    function getMassWriteOffs() {
        $scope.massWriteOffs = $scope.paginator(MassWriteOffs.query, { }, $scope.pageTake, true);
        selectMassWriteOff($scope.scopeHolder.ShowOutdatedPreviews);
    }

    let enableAutoreloadIfNeeded = function() {
        if ($scope.anyMassWriteOffInProcessing()) {
            if ($scope.flagToSwitchToExecuteTab === true) {
                $scope.flagToSwitchToExecuteTab = false;
                $scope.scopeHolder.Tab = "execute";
            }

            if (!$scope.autoreloadObservable)
                $scope.autoreloadObservable = Rx.Observable.interval(5000).timeInterval().subscribe(function () {
                    if ($scope.massWriteOffs && $scope.massWriteOffs.pageIndex === 1)
                        getMassWriteOffs();
                });
        }
        else {
            disableAutoreload();
        }
    }
    
    let disableAutoreload = function() {
        if (!$scope.autoreloadObservable)
            return;

        $scope.autoreloadObservable.dispose();
        $scope.autoreloadObservable = null;
    }
    
    $scope.$watch('scopeHolder.ShowOutdatedPreviews', selectMassWriteOff);

    function selectMassWriteOff(showOutdated) {
        if (!$scope.selectedMassWriteOff)
            $scope.selectedMassWriteOff = $scope.massWriteOffs.items[0];

        if (!$scope.selectedMassWriteOff)
            return;
        
        if (!showOutdated) {
            $scope.selectedMassWriteOff = $scope.selectedMassWriteOff.Status === "Outdated"
                ? $scope.massWriteOffs.items[0]
                : $scope.selectedMassWriteOff;
            
            if ($scope.selectedMassWriteOff.Status === "Outdated")
                $scope.selectedMassWriteOff = null;
        }
    }

    $scope.setSelectedMassWriteOff = function (id) {
        $scope.selectedMassWriteOff = $scope.massWriteOffs.items.filter(function (x) { return x.Id === id; })[0];
    };
    
    $scope.anyNotOutdated = function() {
        let numberOfNotOutdated = $scope.numberOfNotOutdated();
        return numberOfNotOutdated > 0 && $scope.massWriteOffs.items.length >= numberOfNotOutdated;
    }
    
    $scope.numberOfNotOutdated = function () {
        return $scope.massWriteOffs.items.filter(function (x) { return x.Status !== "Outdated"; }).length;
    }

    $scope.allPreviewsOfPageAreOutdated = function() {
        let itIs = !$scope.anyNotOutdated() && !$scope.scopeHolder.ShowOutdatedPreviews && $scope.massWriteOffs.items.length > 0;
        if (itIs)
            $scope.selectedMassWriteOff = null;

        return itIs;
    }
    
    $scope.execute = function (massWriteOffId) {
        $http({
            method: "POST",
            url: "/api/v1/massWriteOff/" + massWriteOffId + "/execute",
        }).then(
            function () {
                getMassWriteOffs();
                $scope.scopeHolder.Tab = "execute";
            }
        );
    }

    $scope.createReport = function (objectId) {
        BulkUpdateContractsFilterBag.setFilter($scope.scopeHolder.Filter);
        
        let body = { MassWriteOffId: objectId, Locale: $scope.scopeHolder.ReportLocale };

        $http({
            method: "POST",
            url: "api/v1/massWriteOff/report",
            data: body,
        }).then(
            function (data) {
                if (data && data.Status !== "Failed") {
                    $location.url("/activities/reporting-files?redirected");
                }
            }
        );
    }

    $scope.download = function (reportId) {
        ReportDownloadService.downloadReport(reportId, $scope.parameters,
            function (downloadInfo) {
                $scope.downloadFile(downloadInfo.data.Url);
            });
    };

    getMassWriteOffs();

    $scope.helpCenterLink = gettextCatalog.currentLanguage.toUpperCase() === 'DE'
        ? 'https://help.frisbii.com/frisbii-transform/docs/de/results'
        : 'https://help.frisbii.com/frisbii-transform/docs/how-to-perform-write-off-in-many-contracts-at-once';
    
    $scope.$on("$destroy", disableAutoreload);
};
MassRevenueWriteOffController.$inject = ["$scope", "$http", "$routeParams", "$window", "$location",
    "PaymentProviderSettings", "ProductInfo", "BulkUpdateContractsFilterBag", "MassWriteOffs", "gettext", 
    "gettextCatalog", "ReportDownloadService", "AccountingExportSettings", "RevenueWriteOffHelper", "PUtill", "DatepickerUtils"];
